import {
  GenericForm,
  GenericFormLogicalField,
  genericBeforeValidate_removeDefaultKeyedError,
  genericValidate_textField,
  ValidationEvent,
  GenericTextFieldValidationOptions,
} from "../../../hooks";

import { replaceAll } from "../../../utils";

const maxMobileNumberLength = 12;

interface MobileFormLogicProps<Form extends GenericForm, App extends unknown> {
  required?: boolean;
  guard?: GenericTextFieldValidationOptions<Form, App>["guard"];
}

export const mobileFormLogic = <Form extends GenericForm, App extends unknown>(
  props: MobileFormLogicProps<Form, App> = {}
): GenericFormLogicalField<Form, App> => ({
  presentation: props,
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: genericValidate_textField({
    guard: props.guard,
    required: props.required,
    customLength: (value: any) => {
      const valueWithoutPlus = replaceAll(value || "", "\\+", "");
      let newValue = valueWithoutPlus.substring(0, maxMobileNumberLength);
      if (((value as string) || "").includes("+")) {
        newValue = `+${newValue}`;
      }
      return {
        value: newValue,
      };
    },
    customErrorValidation: (value: any) => {
      const valueWithoutPlus = replaceAll(value || "", "\\+", "");
      const isAnythingOtherThanDigits = /[^\d]/.test(valueWithoutPlus);
      if (isAnythingOtherThanDigits) {
        return "Please enter a valid number in this field.";
      }
      return null;
    },
  }),
});
